import type { Position } from '../types';

interface PositionTableProps {
  positions: Position[];
}

export default function PositionTable({ positions }: PositionTableProps) {
  if (positions.length === 0) {
    return <p className="text-trader-muted text-sm py-4">No open positions</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-trader-border text-trader-muted text-xs uppercase">
            <th className="text-left py-2 px-3">Token</th>
            <th className="text-left py-2 px-3">Market</th>
            <th className="text-left py-2 px-3">Side</th>
            <th className="text-right py-2 px-3">Size</th>
            <th className="text-right py-2 px-3">Entry Price</th>
          </tr>
        </thead>
        <tbody>
          {positions.map((p) => (
            <tr key={p.id} className="border-b border-trader-border/50 hover:bg-white/5">
              <td className="py-2 px-3 font-mono text-xs">{p.token_id.substring(0, 16)}...</td>
              <td className="py-2 px-3 text-trader-info">{p.market_slug || '\u2014'}</td>
              <td className="py-2 px-3">
                <span className={p.side === 'buy' ? 'text-trader-profit' : 'text-trader-loss'}>
                  {p.side.toUpperCase()}
                </span>
              </td>
              <td className="py-2 px-3 text-right font-mono">{p.size.toFixed(4)}</td>
              <td className="py-2 px-3 text-right font-mono">{p.entry_price.toFixed(4)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
